import React, { Component } from 'react';
import Loaders from 'loaders';
import Modal from '../../../../../components/Modal';
import ClientNotes from './ClientNotes';

export class ClientModalView extends Component {
  constructor(props) {
    super(props);
  }

  getChannels(trade) {
    const channels = [];
    trade.payments && trade.payments.forEach(payment => {
      payment.channels && payment.channels.forEach(channel => {
        channels.push({
          ...payment,
          ...channel,
        });
      });
    });
    return channels;
  }

  render() {
    const {
      client,
      toggleClientModal,
      updateClientTrustStatus,
      updateClientRedeemStatus,
      clientTrades,
    } = this.props;

    let actions = [];

    if(client){
      if(client.trustStatus === 'blocked'){
        actions = [{
          statusAction: 'unblockClient',
          label: 'Un-Block Client',
        }]
      }else if(client.trustStatus === 'trusted'){
        actions = [{
          statusAction: 'untrustClient',
          label: 'Un-Trust Client',
        }]
      }else {
        actions = [
          {
            statusAction: 'trustClient',
            label: 'Trust Client',
          },
          {
            statusAction: 'blockClient',
            label: 'Block Client',
          },
        ];
      }

      if(!client.redeemStatus) {
        actions = actions.concat([
          {
            redeemStatus: 'redeem',
            label: 'Set to "Redeem"',
            className: 'warning',
            action: 'redeemStatus',
          },
          {
            redeemStatus: 'hold',
            label: 'Set to "Hold"',
            className: 'success',
            action: 'redeemStatus',
          },
        ]);
      } else if (client.redeemStatus === 'redeem') {
        actions = actions.concat([
          {
            redeemStatus: null,
            label: 'Remove "Redeem"',
            className: 'secondary',
            action: 'redeemStatus',
          },

          {
            redeemStatus: 'hold',
            label: 'Set to Hold',
            className: 'success',
            action: 'redeemStatus',
          },
        ]);

      } else if (client.redeemStatus === 'hold') {
        actions = actions.concat([
          {
            redeemStatus: 'redeem',
            label: 'Set to Redeem',
            className: 'warning',
            action: 'redeemStatus',
          },
          {
            redeemStatus: null,
            label: 'Remove "Hold"',
            className: 'secondary',
            action: 'redeemStatus',
          },
        ]);

      }
    }

    return (
      <Modal className="modal-container user-info-modal"
             active={true}
             onClose={() => toggleClientModal(false)}>
        {client ? (
          <div>
            <h3>{client.username} {client.trustStatus && (<span>({client.trustStatus})</span>)}</h3>
            <div className="actions">
              {actions.map((item, i)=>(
                <button key={i} className={'button ' + item.className} onClick={(e)=>{
                  e.preventDefault();
                  if (item.action === 'redeemStatus') {
                    updateClientRedeemStatus(item.redeemStatus, client.username);
                  } else {
                    updateClientTrustStatus(item.statusAction, client.username);
                  }
                }}>{item.label}</button>
              ))}
            </div>

            <div className="trade-info">
              <div className="info-item">
                <span>Joined:</span>
                {client.joined}
              </div>
              <div className="info-item">
                <span>Total Bitcoin:</span>
                {client.total_btc}
              </div>
              <div className="info-item">
                <span>Blocked By:</span>
                {client.blocked_by}
              </div>
              <div className="info-item">
                <span>Negative Feedback:</span>
                {client.feedback_negative}
              </div>
              <div className="info-item">
                <span>Neutral Feedback:</span>
                {client.feedback_neutral}
              </div>
              <div className="info-item">
                <span>Positive Feedback:</span>
                {client.feedback_positive}
              </div>
              <div className="info-item">
                <span>Total Partners:</span>
                {client.total_partners}
              </div>
              <div className="info-item">
                <span>Total Trades:</span>
                {client.total_trades}
              </div>
              <div className="info-item">
                <span>Trusted By:</span>
                {client.trusted_by}
              </div>
              <div className="info-item">
                <span>Email Verified:</span>
                {client.email_verified ? 'yes' : 'no'}
              </div>
              <div className="info-item">
                <span>Is Verified:</span>
                {client.is_verified ? 'yes' : 'no'}
              </div>
            </div>
            <ClientNotes client={client}/>

            <h4>Past Trades</h4>
            {clientTrades && (
              <div className="past-trades">
                <table>
                  <thead>
                  <tr>
                    <th>Trade ID</th>
                    <th>Date</th>
                    <th>Type</th>
                    <th>$</th>
                    <th>Status</th>
                    <th>Fraud</th>
                  </tr>
                  </thead>
                  <tbody>
                  {clientTrades.map((trade, i) => {
                    let trClassName = '';
                    if(trade.fraud){
                      trClassName = 'fraud';
                    }else if(trade.helpRequested) {
                      trClassName = 'help';
                    }else if(trade.flagged) {
                      trClassName = 'flagged';
                    }else if(trade.trade_status === 'Dispute open' || trade.isBlacklisted) {
                      trClassName = 'blocked';
                    }
                    return (
                      <tr key={i} className={trClassName}>
                        <td><a href={`/#/workArea/trades/completed?tradeId=${trade.tradeId}`} target="_blank">{trade.tradeId}</a></td>
                        <td>{(new Date(trade.date)).toLocaleString()}</td>
                        <td>{trade.type}</td>
                        <td>{trade.amount}</td>
                        <td>{trade.trade_status}</td>
                        <td>
                          {trade.fraud && (
                            <span className="fraud">Fraud</span>
                          )}
                        </td>
                        <td>
                          {this.getChannels(trade).map((channel, i)=>(
                            <div className="channel" key={i}>
                              {channel.type} - {channel.status}
                            </div>
                          ))}

                        </td>
                      </tr>
                    );
                  })}
                  </tbody>
                </table>

              </div>
            )}
          </div>
        ) : (
          <Loaders  width="50" height="50" />
        )}

      </Modal>
    );
  }

}

export default ClientModalView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/ClientModal/ClientModal.view.js